var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"canvas",staticClass:"base-echart",on:{"mouseenter":_vm.pauseTooltipAutoplay,"mouseleave":_vm.resumeTooltipAutoplay}})}
var staticRenderFns = []

export { render, staticRenderFns }